/**
 * Faculty role helpers. CBC may be expressed as legacy `role: 'cbcfaculty'`, or
 * `role: 'faculty'` with `subtype: 'cbc'` (or legacy `facultyType: 'cbc'`).
 *
 * @param {{ role?: string, subtype?: string, facultyType?: string } | null | undefined} user
 */

export function isCbcFaculty(user) {
  if (!user) return false;
  if (user.role === 'cbcfaculty') return true;
  if (user.role === 'faculty' && user.subtype === 'cbc') return true;
  if (user.role === 'faculty' && user.facultyType === 'cbc') return true;
  return false;
}

export function isTeachingFacultyRole(user) {
  if (!user) return false;
  return user.role === 'faculty' || isCbcFaculty(user);
}

/** Course / lab / question / project teaching surfaces (faculty + cbcfaculty). */
export function canAccessTeaching(user) {
  return isTeachingFacultyRole(user);
}
